import { useEffect, useRef, useState } from 'react'
import styles from './BarcodeScannerUSB.module.scss'

export const BarcodeScannerUSB = ({ scannedBarcodes, setScannedBarcodes }) => {
  const [scannedData, setScannedData] = useState('')
  const inputRef = useRef(null)

  useEffect(() => {
    // Focus the input field only if it exists
    if (inputRef.current) {
      inputRef.current.focus()
    }

    // Add event listener for keydown to detect barcode scanner input
    const handleKeyDown = (event) => {
      // console.log(event)
      if (event.key === 'Enter' && scannedData) {
        event.preventDefault()
        // console.log('Scanned Barcode:', scannedData)

        if (!scannedBarcodes.includes(scannedData)) {
          setScannedBarcodes([...scannedBarcodes, scannedData.trim()])
        } else {
          alert('Already scanned this barcode.')
        }
        // Optionally clear the input after processing
        setScannedData('')
        // Re-focus the input after clearing
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }
    }

    // Add event listener to the input field
    const inputElement = inputRef.current
    if (inputElement) {
      inputElement.addEventListener('keydown', handleKeyDown)
    }

    // Cleanup event listener on component unmount
    return () => {
      if (inputElement) {
        inputElement.removeEventListener('keydown', handleKeyDown)
      }
    }
  }, [scannedData])

  return (
    <div className='container'>
      <h2>USB Barcode Scanner</h2>
      <div className={styles['input__container']}>
        <input
          className={styles['input']}
          ref={inputRef}
          type='text'
          value={scannedData}
          onChange={(e) => setScannedData(e.target.value)}
          placeholder='Click here and then scan a barcode'
          autoFocus
        />
      </div>
    </div>
  )
}
